// Sonner-based toast wrapper themed with brand vars. One <Toaster />
// at the app root; pages call toast.success(...) / toast.error(...).
import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      theme="light"
      richColors
      closeButton
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-paper group-[.toaster]:text-ink group-[.toaster]:border-border group-[.toaster]:rounded-2xl group-[.toaster]:shadow-[var(--tk-shadow-pop)] group-[.toaster]:font-ui",
          description: "group-[.toast]:text-ink-3",
          actionButton:
            "group-[.toast]:bg-anor group-[.toast]:text-primary-foreground group-[.toast]:rounded-full",
          cancelButton:
            "group-[.toast]:bg-secondary group-[.toast]:text-ink group-[.toast]:rounded-full",
        },
      }}
    />
  );
}

export { toast } from "sonner";
